import { useContext } from 'react';
import PropTypes from 'prop-types';
import { params, shape, string, useDataModel } from '@thd-nucleus/data-sources';
import { useConfigService } from '@thd-nucleus/experience-context';
import { RedirectTag, useHelmet } from '@thd-nucleus/thd-helmet';
import { RedirectContext } from './RedirectContext';
import { isInvalidItemId, isInvalidCanonical, isNotFound } from './rules/rental-redirect-rules';
import { handleErrors, ERROR_HANDLING_EXPERIENCE } from '../utils/redirector-utils';

const rentalHandler = ({ data, error: err, props, queries }) => {

  let error = err;
  if (queries && queries.length && !err) {
    const productQuery = queries.find((query) => query.operationName === 'product');
    if (productQuery && productQuery.error) {
      error = productQuery.error;
    }
  }

  const invalidItemId = isInvalidItemId({ itemId: props.itemId });
  if (invalidItemId) {
    return new RedirectTag(invalidItemId, props.bypass);
  }

  const errors = handleErrors(error, ERROR_HANDLING_EXPERIENCE.PRODUCT);
  if (errors) {
    return new RedirectTag(errors, props.bypass);
  }

  const notFound = isNotFound({ data, itemId: props.itemId });
  if (notFound) {
    return new RedirectTag(notFound, props.bypass);
  }

  const {
    disableCanonicalRedirect,
    pathWithQueryParams
  } = props;

  const [path] = pathWithQueryParams.split('?') || '';

  const invalidCanonical = isInvalidCanonical({ data, disableCanonicalRedirect, path });
  if (invalidCanonical) {
    return new RedirectTag(invalidCanonical, props.bypass);
  }

  return null;
};

export const RentalRedirector = (props) => {
  
  const disableCanonicalRedirectFS = useConfigService('fs-prop:pip-wrapper__redirector--disableCanonicalRedirect');
  const { disableCanonicalRedirect } = props;

  const { pathWithQueryParams, itemId, bypass } = useContext(RedirectContext);

  const handlerProps = {
    pathWithQueryParams,
    disableCanonicalRedirect: typeof disableCanonicalRedirectFS !== 'undefined'
      ? disableCanonicalRedirectFS
      : disableCanonicalRedirect,
    itemId,
    bypass
  };

  const opts = {
    variables: {
      itemId
    },
    skip: !itemId
  };

  const { data, error } = useDataModel('product', opts);
  useHelmet('rentalRedirector', { data, error, props: handlerProps }, rentalHandler, [itemId]);

  return null;
};

RentalRedirector.displayName = 'RentalRedirector';

RentalRedirector.propTypes = {
  disableCanonicalRedirect: PropTypes.bool
};

RentalRedirector.defaultProps = {
  disableCanonicalRedirect: false
};

RentalRedirector.dataModel = {
  product: params({ itemId: string().isRequired(), dataSource: string() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      canonicalUrl: string()
    })
  })
};
